import { render, staticRenderFns } from "./AnnexPanel.vue?vue&type=template&id=1f62368f&scoped=true&"
import script from "./AnnexPanel.vue?vue&type=script&lang=js&"
export * from "./AnnexPanel.vue?vue&type=script&lang=js&"
import style0 from "./AnnexPanel.vue?vue&type=style&index=0&id=1f62368f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f62368f",
  null
  
)

export default component.exports